import { proxy } from 'valtio';
export const david_store = proxy({
    rangeHigh: 0,
    rangeLow: 0,
    close: 0,
});
